/**
 * Footer link columns.
 *
 * The markup ships expanded so the links are reachable when this script never
 * runs, and so desktop — where the columns are plain columns, not disclosures —
 * needs no JavaScript at all. Below 1150px Figma 2575:7922 asks for every
 * accordion to start closed, which is what this collapses them to.
 */

const MOBILE_QUERY = '(max-width: 1149px)';

class FooterLinksDisclosure extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();

    const query = matchMedia(MOBILE_QUERY);
    this.#sync(query.matches);

    query.addEventListener('change', (event) => this.#sync(event.matches), {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /**
   * Only runs on load and when the breakpoint is actually crossed, so a column
   * the visitor opened on mobile is not closed again while they stay on mobile.
   */
  #sync(isMobile) {
    const details = this.querySelector('details');

    if (!details) return;

    details.open = !isMobile;
    details.setAttribute('aria-expanded', String(!isMobile));
  }
}

if (!customElements.get('footer-links-disclosure')) {
  customElements.define('footer-links-disclosure', FooterLinksDisclosure);
}
